import React from "react";
import { Script, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { SliceZone } from "@prismicio/react";
import { components } from "../slices";

export default function Jobs({ data }) {
  const heroHeadline = data.prismicJobsPage.data.hero_headline.text;
  const heroDescription = data.prismicJobsPage.data.hero_description.text;
  const heroCta = data.prismicJobsPage.data.hero_cta.text;
  const heroFluidImage = data.prismicJobsPage.data.hero_image.gatsbyImageData;

  const doc = data.prismicJobsPage.data;
  return (
    <>
      <Script
        key="ashby"
        type="text/javascript"
        src="https://jobs.ashbyhq.com/bankjoy/embed"
      />
      <Script
        key="ashby"
        type="text/javascript"
        src="https://bankjoy.com/scripts/salesloft.js"
      />
      <>
        <div className=" md:mt-16 mt-8">
          <div className="flex md:flex-row flex-col items-center mx-auto max-w-6xl px-8">
            <div className="flex w-full md:w-1/3 flex-col">
              <h1 className="mb-2 text-5xl text-center md:text-left">
                {heroHeadline}
              </h1>
              <p className="mb-2 md:mb-8 text-center md:text-left max-w-xl md:pr-6">
                {heroDescription}
              </p>
              <a
                href="#ashby_embed"
                className="bg-blue capitalize my-2 md:my-0 self-center md:self-start w-max px-3 pb-1.5 hoverShadow pt-1 font-semibold text-white rounded-full"
              >
                {heroCta}
              </a>
            </div>
            <div className="w-full md:w-2/3 md:ml-16">
              <div className="">
                <GatsbyImage image={heroFluidImage} />
              </div>
              <div className="uppercase text-xs mt-3 tracking-wide text-center font-semibold  text-blue-dark">
                Where We Work
              </div>
            </div>
          </div>
          <SliceZone slices={doc.body} components={components} />
          <h2 className="mt-2 md:mt-28 text-center mb-4 md:mb-6 font-bold text-3xl md:text-4xl">
            Current Job Openings
          </h2>
          <div id="ashby_embed" className="font-sans"></div>
        </div>
      </>
    </>
  );
}

export function Head({ data }) {
  return (
    <>
      <html lang="en" /> <title>Bankjoy — Jobs</title>
      <meta
        name="description"
        content="Bankjoy delivers award-winning banking technology, including mobile banking, online banking, e-statements, online account opening, online loan origination, and conversational AI to banks and credit unions — big and small."
      />
      <link rel="preload" href="/fonts/fonts.css" as="style"></link>
      <link rel="canonical" href="https://bankjoy.com/jobs" />
      <meta
        name="image"
        property="og:image"
        content={data.prismicHomepage.data.ogimage.url}
      />
    </>
  );
}

export const query = graphql`
  {
    prismicHomepage {
      data {
        ogimage {
          url
        }
      }
    }

    prismicJobsPage {
      data {
        hero_cta {
          text
        }
        hero_description {
          text
        }
        hero_headline {
          text
        }
        hero_image {
          gatsbyImageData
        }
        body {
          ... on PrismicJobsPageDataBodyCoreValue {
            slice_type
            items {
              value_description {
                text
              }
              value_image {
                gatsbyImageData
                alt
              }
              value_title {
                text
              }
            }
          }
          ... on PrismicJobsPageDataBodyBenefitsPerks {
            slice_type
            items {
              benefit_title {
                text
              }
              benefit_icon {
                gatsbyImageData
                alt
              }
            }
          }
        }
      }
    }
  }
`;
